/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { HrEventTypeDto } from '../models';
// @ts-ignore
import type { HrEventsResultDto } from '../models';
// @ts-ignore
import type { HrEventsSortByDto } from '../models';
// @ts-ignore
import type { HrEventsSummaryDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * HrStatisticsApi - axios parameter creator
 * @export
 */
export const HrStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (od dzis do dzis + 30 dni wlacznie, to samo okno co symbol dlugopisu na liscie pracownikow obszaru), powroty z dlugotrwalej absencji (14 dni wprzod), urodziny (od 2 dni wstecz do 7 dni wprzod, jak powiadomienia o urodzinach). Zawezone do podleglego obszaru.
         * @summary HR events summary (kafelki + wykresy)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
         * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrEventsSummary: async (accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hr/events/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (departmentCodes) {
                localVarQueryParameter['departmentCodes'] = departmentCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien). To jest zrodlo danych per osoba dla blokow, ktore events-summary opisuje samymi liczbami — m.in. konczacych sie umow na stronie startowej HRBP (eventType=CONTRACT_ENDING, dateFrom=dzis, dateTo=dzis+30). Nie budujemy do tego osobnego odczytu. 
         * @summary Paginated list of employees with an HR event (osoba + event)
         * @param {HrEventTypeDto} eventType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {Array<EmployeeAccessTypeDto>} [accessTypes] Zakresy widocznosci (widok v_user_employee_access). Mozna podac wiecej niz jeden — wynik jest suma zakresow, wiec przelozony bedacy P1 dla jednych osob i P2 dla innych dostaje obie grupy w jednej liscie. Brak parametru oznacza HRBP. Zakres, ktorego wolajacy nie ma, nic nie dokłada. 
         * @param {string} [dateFrom] Poczatek okna zdarzen. Brak parametru oznacza brak ograniczenia z dolu — endpoint nie ma domyslnego okna. Zeby lista osob zgadzala sie z licznikiem z events-summary (blok zmian kadrowych na stronie startowej HRBP), podaj dateFrom &#x3D; dzis, a dla BIRTHDAY dateFrom &#x3D; dzis - 2 dni. Data urodzin to pierwsza rocznica w dniu dateFrom lub pozniej (bez dateFrom liczona od dzis), wiec okno zaczynajace sie przed dzisiaj obejmuje tez urodziny, ktore juz minely. 
         * @param {string} [dateTo] Koniec okna zdarzen. Brak parametru oznacza brak ograniczenia z gory. Okno kafelkow i wykresow w events-summary to 14 dni, czyli dateTo &#x3D; dzis + 13 dni. Wyjatki: dla CONTRACT_ENDING dateTo &#x3D; dzis + 30 dni, dla BIRTHDAY dateTo &#x3D; dzis + 7 dni. 
         * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
         * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
         * @param {string} [search] Szukanie po imieniu/nazwisku.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {HrEventsSortByDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHrEvents: async (eventType: HrEventTypeDto, page: number, pageSize: number, accessTypes?: Array<EmployeeAccessTypeDto>, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('listHrEvents', 'eventType', eventType)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('listHrEvents', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('listHrEvents', 'pageSize', pageSize)
            const localVarPath = `/api/v2/hr/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            if (accessTypes) {
                localVarQueryParameter['accessTypes'] = accessTypes.join(COLLECTION_FORMATS.csv);
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (departmentCodes) {
                localVarQueryParameter['departmentCodes'] = departmentCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HrStatisticsApi - functional programming interface
 * @export
 */
export const HrStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HrStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (od dzis do dzis + 30 dni wlacznie, to samo okno co symbol dlugopisu na liscie pracownikow obszaru), powroty z dlugotrwalej absencji (14 dni wprzod), urodziny (od 2 dni wstecz do 7 dni wprzod, jak powiadomienia o urodzinach). Zawezone do podleglego obszaru.
         * @summary HR events summary (kafelki + wykresy)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
         * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HrEventsSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHrEventsSummary(accessType, departmentCodes, regionCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HrStatisticsApi.getHrEventsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien). To jest zrodlo danych per osoba dla blokow, ktore events-summary opisuje samymi liczbami — m.in. konczacych sie umow na stronie startowej HRBP (eventType=CONTRACT_ENDING, dateFrom=dzis, dateTo=dzis+30). Nie budujemy do tego osobnego odczytu. 
         * @summary Paginated list of employees with an HR event (osoba + event)
         * @param {HrEventTypeDto} eventType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {Array<EmployeeAccessTypeDto>} [accessTypes] Zakresy widocznosci (widok v_user_employee_access). Mozna podac wiecej niz jeden — wynik jest suma zakresow, wiec przelozony bedacy P1 dla jednych osob i P2 dla innych dostaje obie grupy w jednej liscie. Brak parametru oznacza HRBP. Zakres, ktorego wolajacy nie ma, nic nie dokłada. 
         * @param {string} [dateFrom] Poczatek okna zdarzen. Brak parametru oznacza brak ograniczenia z dolu — endpoint nie ma domyslnego okna. Zeby lista osob zgadzala sie z licznikiem z events-summary (blok zmian kadrowych na stronie startowej HRBP), podaj dateFrom &#x3D; dzis, a dla BIRTHDAY dateFrom &#x3D; dzis - 2 dni. Data urodzin to pierwsza rocznica w dniu dateFrom lub pozniej (bez dateFrom liczona od dzis), wiec okno zaczynajace sie przed dzisiaj obejmuje tez urodziny, ktore juz minely. 
         * @param {string} [dateTo] Koniec okna zdarzen. Brak parametru oznacza brak ograniczenia z gory. Okno kafelkow i wykresow w events-summary to 14 dni, czyli dateTo &#x3D; dzis + 13 dni. Wyjatki: dla CONTRACT_ENDING dateTo &#x3D; dzis + 30 dni, dla BIRTHDAY dateTo &#x3D; dzis + 7 dni. 
         * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
         * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
         * @param {string} [search] Szukanie po imieniu/nazwisku.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {HrEventsSortByDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessTypes?: Array<EmployeeAccessTypeDto>, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HrEventsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHrEvents(eventType, page, pageSize, accessTypes, dateFrom, dateTo, departmentCodes, regionCodes, search, sortOrder, sortBy, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HrStatisticsApi.listHrEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HrStatisticsApi - factory interface
 * @export
 */
export const HrStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HrStatisticsApiFp(configuration)
    return {
        /**
         * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (od dzis do dzis + 30 dni wlacznie, to samo okno co symbol dlugopisu na liscie pracownikow obszaru), powroty z dlugotrwalej absencji (14 dni wprzod), urodziny (od 2 dni wstecz do 7 dni wprzod, jak powiadomienia o urodzinach). Zawezone do podleglego obszaru.
         * @summary HR events summary (kafelki + wykresy)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
         * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsSummaryDto> {
            return localVarFp.getHrEventsSummary(accessType, departmentCodes, regionCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien). To jest zrodlo danych per osoba dla blokow, ktore events-summary opisuje samymi liczbami — m.in. konczacych sie umow na stronie startowej HRBP (eventType=CONTRACT_ENDING, dateFrom=dzis, dateTo=dzis+30). Nie budujemy do tego osobnego odczytu. 
         * @summary Paginated list of employees with an HR event (osoba + event)
         * @param {HrEventTypeDto} eventType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {Array<EmployeeAccessTypeDto>} [accessTypes] Zakresy widocznosci (widok v_user_employee_access). Mozna podac wiecej niz jeden — wynik jest suma zakresow, wiec przelozony bedacy P1 dla jednych osob i P2 dla innych dostaje obie grupy w jednej liscie. Brak parametru oznacza HRBP. Zakres, ktorego wolajacy nie ma, nic nie dokłada. 
         * @param {string} [dateFrom] Poczatek okna zdarzen. Brak parametru oznacza brak ograniczenia z dolu — endpoint nie ma domyslnego okna. Zeby lista osob zgadzala sie z licznikiem z events-summary (blok zmian kadrowych na stronie startowej HRBP), podaj dateFrom &#x3D; dzis, a dla BIRTHDAY dateFrom &#x3D; dzis - 2 dni. Data urodzin to pierwsza rocznica w dniu dateFrom lub pozniej (bez dateFrom liczona od dzis), wiec okno zaczynajace sie przed dzisiaj obejmuje tez urodziny, ktore juz minely. 
         * @param {string} [dateTo] Koniec okna zdarzen. Brak parametru oznacza brak ograniczenia z gory. Okno kafelkow i wykresow w events-summary to 14 dni, czyli dateTo &#x3D; dzis + 13 dni. Wyjatki: dla CONTRACT_ENDING dateTo &#x3D; dzis + 30 dni, dla BIRTHDAY dateTo &#x3D; dzis + 7 dni. 
         * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
         * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
         * @param {string} [search] Szukanie po imieniu/nazwisku.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {HrEventsSortByDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessTypes?: Array<EmployeeAccessTypeDto>, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsResultDto> {
            return localVarFp.listHrEvents(eventType, page, pageSize, accessTypes, dateFrom, dateTo, departmentCodes, regionCodes, search, sortOrder, sortBy, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HrStatisticsApi - interface
 * @export
 * @interface HrStatisticsApi
 */
export interface HrStatisticsApiInterface {
    /**
     * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (od dzis do dzis + 30 dni wlacznie, to samo okno co symbol dlugopisu na liscie pracownikow obszaru), powroty z dlugotrwalej absencji (14 dni wprzod), urodziny (od 2 dni wstecz do 7 dni wprzod, jak powiadomienia o urodzinach). Zawezone do podleglego obszaru.
     * @summary HR events summary (kafelki + wykresy)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
     * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApiInterface
     */
    getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsSummaryDto>;

    /**
     * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien). To jest zrodlo danych per osoba dla blokow, ktore events-summary opisuje samymi liczbami — m.in. konczacych sie umow na stronie startowej HRBP (eventType=CONTRACT_ENDING, dateFrom=dzis, dateTo=dzis+30). Nie budujemy do tego osobnego odczytu. 
     * @summary Paginated list of employees with an HR event (osoba + event)
     * @param {HrEventTypeDto} eventType 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {Array<EmployeeAccessTypeDto>} [accessTypes] Zakresy widocznosci (widok v_user_employee_access). Mozna podac wiecej niz jeden — wynik jest suma zakresow, wiec przelozony bedacy P1 dla jednych osob i P2 dla innych dostaje obie grupy w jednej liscie. Brak parametru oznacza HRBP. Zakres, ktorego wolajacy nie ma, nic nie dokłada. 
     * @param {string} [dateFrom] Poczatek okna zdarzen. Brak parametru oznacza brak ograniczenia z dolu — endpoint nie ma domyslnego okna. Zeby lista osob zgadzala sie z licznikiem z events-summary (blok zmian kadrowych na stronie startowej HRBP), podaj dateFrom &#x3D; dzis, a dla BIRTHDAY dateFrom &#x3D; dzis - 2 dni. Data urodzin to pierwsza rocznica w dniu dateFrom lub pozniej (bez dateFrom liczona od dzis), wiec okno zaczynajace sie przed dzisiaj obejmuje tez urodziny, ktore juz minely. 
     * @param {string} [dateTo] Koniec okna zdarzen. Brak parametru oznacza brak ograniczenia z gory. Okno kafelkow i wykresow w events-summary to 14 dni, czyli dateTo &#x3D; dzis + 13 dni. Wyjatki: dla CONTRACT_ENDING dateTo &#x3D; dzis + 30 dni, dla BIRTHDAY dateTo &#x3D; dzis + 7 dni. 
     * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
     * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
     * @param {string} [search] Szukanie po imieniu/nazwisku.
     * @param {SortDirectionDto} [sortOrder] 
     * @param {HrEventsSortByDto} [sortBy] 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApiInterface
     */
    listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessTypes?: Array<EmployeeAccessTypeDto>, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsResultDto>;

}

/**
 * HrStatisticsApi - object-oriented interface
 * @export
 * @class HrStatisticsApi
 * @extends {BaseAPI}
 */
export class HrStatisticsApi extends BaseAPI implements HrStatisticsApiInterface {
    /**
     * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (od dzis do dzis + 30 dni wlacznie, to samo okno co symbol dlugopisu na liscie pracownikow obszaru), powroty z dlugotrwalej absencji (14 dni wprzod), urodziny (od 2 dni wstecz do 7 dni wprzod, jak powiadomienia o urodzinach). Zawezone do podleglego obszaru.
     * @summary HR events summary (kafelki + wykresy)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
     * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApi
     */
    public getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig) {
        return HrStatisticsApiFp(this.configuration).getHrEventsSummary(accessType, departmentCodes, regionCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien). To jest zrodlo danych per osoba dla blokow, ktore events-summary opisuje samymi liczbami — m.in. konczacych sie umow na stronie startowej HRBP (eventType=CONTRACT_ENDING, dateFrom=dzis, dateTo=dzis+30). Nie budujemy do tego osobnego odczytu. 
     * @summary Paginated list of employees with an HR event (osoba + event)
     * @param {HrEventTypeDto} eventType 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {Array<EmployeeAccessTypeDto>} [accessTypes] Zakresy widocznosci (widok v_user_employee_access). Mozna podac wiecej niz jeden — wynik jest suma zakresow, wiec przelozony bedacy P1 dla jednych osob i P2 dla innych dostaje obie grupy w jednej liscie. Brak parametru oznacza HRBP. Zakres, ktorego wolajacy nie ma, nic nie dokłada. 
     * @param {string} [dateFrom] Poczatek okna zdarzen. Brak parametru oznacza brak ograniczenia z dolu — endpoint nie ma domyslnego okna. Zeby lista osob zgadzala sie z licznikiem z events-summary (blok zmian kadrowych na stronie startowej HRBP), podaj dateFrom &#x3D; dzis, a dla BIRTHDAY dateFrom &#x3D; dzis - 2 dni. Data urodzin to pierwsza rocznica w dniu dateFrom lub pozniej (bez dateFrom liczona od dzis), wiec okno zaczynajace sie przed dzisiaj obejmuje tez urodziny, ktore juz minely. 
     * @param {string} [dateTo] Koniec okna zdarzen. Brak parametru oznacza brak ograniczenia z gory. Okno kafelkow i wykresow w events-summary to 14 dni, czyli dateTo &#x3D; dzis + 13 dni. Wyjatki: dla CONTRACT_ENDING dateTo &#x3D; dzis + 30 dni, dla BIRTHDAY dateTo &#x3D; dzis + 7 dni. 
     * @param {Array<string>} [departmentCodes] Kody ze slownika DEPARTMENT (wartosci enuma Department). Filtr po obszarze funkcyjnym pracownika.
     * @param {Array<string>} [regionCodes] Kody ze slownika REGION (np. R17). Filtr po kodzie regionu pracownika.
     * @param {string} [search] Szukanie po imieniu/nazwisku.
     * @param {SortDirectionDto} [sortOrder] 
     * @param {HrEventsSortByDto} [sortBy] 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApi
     */
    public listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessTypes?: Array<EmployeeAccessTypeDto>, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return HrStatisticsApiFp(this.configuration).listHrEvents(eventType, page, pageSize, accessTypes, dateFrom, dateTo, departmentCodes, regionCodes, search, sortOrder, sortBy, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

